<template><StoreEditor /></template>
<script>
import StoreEditor from './StoreEditor.vue';
export default { components: { StoreEditor } };
</script>
